exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container-kYDsd{margin-bottom:20px;width:100%}.top-2kKjK{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:5px}.title-2S70K{font-size:.8rem;font-weight:600;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-column-gap:6px;-moz-column-gap:6px;column-gap:6px}.title-2S70K .info-2Z5Nn{white-space:nowrap}.required-2HUzP{color:#0a81ff}.requiredMessage-3Qaui{padding:2px 10px;background-color:#0a81ff;text-transform:uppercase;font-size:9px}.theme-dark .required-2HUzP{color:#fff}.theme-dark .requiredMessage-3Qaui{background-color:#0a81ff}.theme-light .required-2HUzP{color:#212121}.theme-light .requiredMessage-3Qaui{color:#fff;background-color:#0a81ff}", ""]);

// exports
exports.locals = {
	"container": "container-kYDsd",
	"top": "top-2kKjK",
	"title": "title-2S70K",
	"info": "info-2Z5Nn",
	"required": "required-2HUzP",
	"requiredMessage": "requiredMessage-3Qaui"
};